// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Userform_fieldset__qPJOJ","editInfoButton":"Userform_editInfoButton__tN7xq","cancelButton":"Userform_cancelButton__BIS9u"};